module.exports = __webpack_public_path__ + "static/img/site.79dda0d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/site.png
// module id = is6L
// module chunks = 0